import { activationCodeField, defaultSignUpFields, schoolField } from './questions.shared';
import { OnboardingQuestion } from '../onboarding.types';

type StudentQuestionKey = 'WHAT_BRINGS_YOU_HERE' | 'CREATE_ACCOUNT' | 'ACTIVATION_CODE';

export const STUDENT_QUESTIONS = (): Record<StudentQuestionKey, OnboardingQuestion> => {
  return {
    WHAT_BRINGS_YOU_HERE: {
      title: 'What brings you here?',
      subTitle: 'We’ll help you achieve your aspirations.',
      featuredIcon: 'UserCircle',
      onComplete: 'CONTINUE_WITHOUT_SUBMIT',

      question: {
        profile_option_category_id: 'onboarding',
        profile_option_question_id: 'what_brings_you_here',
        profile_option_source: 'onboarding',

        type: 'CHECKBOX',
        rules: {
          required: 'Please select at least one option',
        },
        options: [
          {
            label: 'Explore careers or majors',
            value: 'student_careers_or_majors',
            recommendation: ['discover_jobs_sticker', 'resume_optimizer', 'boost_your_profile'],
          },
          {
            label: 'Get into a great college/graduate school',
            value: 'student_college_or_graduate_school',
            recommendation: [
              'explore_universities_sticker',
              'college_shortlist',
              'improve_test_scores',
            ],
          },
          {
            label: 'Land an internship or job',
            value: 'student_internship_or_job',
            recommendation: ['discover_jobs_sticker', 'resume_optimizer', 'boost_your_profile'],
          },
          {
            label: 'Secure scholarships and financial aid',
            value: 'student_scholarships_and_financial_aid',
            recommendation: ['find_scholarships_sticker', 'lower_cost_of_college', 'extra_cash'],
          },
          {
            label: 'Securing extra cash',
            value: 'student_securing_extra_cash',
            recommendation: ['find_scholarships_sticker', 'lower_cost_of_college', 'extra_cash'],
          },
          {
            label: 'Improve mental/physical health',
            value: 'student_mental_physical_health',
            recommendation: [
              'navigating_stress',
              'sleep_restoration',
              'family_dynamics',
              'growth_mindset',
            ],
          },
          {
            label: 'Make professional connections',
            value: 'student_professional_connections',
            recommendation: ['networking', 'seek_support'],
          },
        ],
      },
    },
    CREATE_ACCOUNT: {
      title: 'Create your account',
      subTitle: 'Sign up in less than 2 minutes.',
      featuredIcon: 'UserCircle',
      onComplete: 'CONTINUE_WITHOUT_SUBMIT',

      subAction: {
        body: 'Already have an account?',
        actionText: 'Log in',
        onClick: 'LOGIN',
      },
      question: {
        type: 'FORM',
        fields: [
          ...defaultSignUpFields,
          {
            name: 'zip_code',
            placeholder: 'Enter your zip code',
            type: 'text',
            rules: {
              required: 'Zip code is required',
            },
          },
          {
            name: 'grade',
            placeholder: 'Select your grade',
            type: 'text',

            selectOptions: {
              renderAsSelect: true,
              type: 'SINGLE',

              options: [
                { label: '9th Grade', value: '9' },
                { label: '10th Grade', value: '10' },
                { label: '11th Grade', value: '11' },
                { label: '12th Grade', value: '12' },
                { label: 'Year 1 Post Secondary', value: 'Year 1 Post Secondary' },
                { label: 'Year 2 Post Secondary', value: 'Year 2 Post Secondary' },
                { label: 'Year 3 Post Secondary', value: 'Year 3 Post Secondary' },
                { label: 'Year 4 Post Secondary', value: 'Year 4 Post Secondary' },
              ],
            },
          },
          schoolField,
        ],
      },
    },
    ACTIVATION_CODE: {
      title: 'Activation code',
      subTitle: 'Sign up in less than 2 minutes.',
      featuredIcon: 'UserCircle',
      onComplete: 'SUBMIT_USER_INFO',
      question: {
        type: 'FORM',
        fields: [activationCodeField],
      },
      subAction: {
        body: 'Don’t have an activation code?',
        actionText: 'Skip',
        onClick: 'SKIP',
      },
    },
  };
};

export const QUESTION_INDEX_TO_FIELDS_STUDENT: Record<number, string[]> = {
  0: ['what_brings_you_here'], // WHAT_BRINGS_YOU_HERE
  1: ['first_name', 'last_name', 'phone', 'email', 'password', 'grade', 'school', 'zip_code'], // CREATE_ACCOUNT
  2: ['invite_code'], // ACTIVATION_CODE
};
